window.Laroute = require('../laroute');



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap/laroute.js